import { useContext } from 'react';
import SpinnerIcon from '@pelckmans/elementis/icons/spinner';
import { ExerciseTranslationsContext } from '../contexts/ExerciseTranslationsContext';

export function ExerciseLoading() {
  const translations = useContext(ExerciseTranslationsContext);

  return (
    <div className="exercise-container">
      <div className="content">
        <SpinnerIcon data-testid="spinner" className="loading-icon" size="xl" />
        <div className="body">
          <h1 className="title">{translations.exerciseLoading.title}</h1>
          <div>
            <p>{translations.exerciseLoading.p1}</p>
            <p>{translations.exerciseLoading.p2}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
